import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Appointment, CalendarResponse } from '../model/appointment.model';
import { BrandService } from '../service/brand.service';
import { LoadingService } from '../service/loading.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-appointment-confirm',
  templateUrl: './appointment-confirm.component.html',
  styleUrls: ['../appointment/appointment.component.css', './appointment-confirm.component.css']
})
export class AppointmentConfirmComponent implements OnInit {
  public model: Appointment;
  public brandId: number;
  public french: boolean;
  public step: number;
  public gobacklink: string;
  public share: CalendarResponse;
  public completed: boolean;

  constructor(private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private brandService: BrandService,
    private router: Router,
    private translate: TranslateService) {
    this.french = this.brandService.inFrench();
    this.brandId = this.brandService.checkBrand(this.route.snapshot.params);
    this.loadingService.setColor(this.brandId.toString());
    this.loadingService.show();
  }

  ngOnInit() {
    this.http.get<Appointment>(this.baseUrl + 'Appointment/UpdateAppointment/' + this.route.snapshot.params.appointmentid).subscribe(response => {
      this.step = 3;
      this.model = response;
      this.model.copied = false;
      this.loadingService.hide();
      this.brandService.setTitle(this.model.brandId, this.model.brandName);
      var share = '';
      switch (this.model.brandId) {
        case 372:
          share = "https://invite.career.college/invitation/" + this.model.contactId;
          this.gobacklink = "https://www.career.college/";
          break;
        case 373:
          share = this.french ? "https://invitation.collegecdi.ca/invitation/" + this.model.contactId : "https://invite.cdicollege.ca/invitation/" + this.model.contactId;
          this.gobacklink = this.french ? "https://www.collegecdi.ca/" : "https://www.cdicollege.ca/";
          break;
        case 374:
          share = "https://invite.reevescollege.ca/invitation/" + this.model.contactId;
          this.gobacklink = "https://www.reevescollege.ca/";
          break;
        case 543:
          share = "https://invite.vcad.ca/invitation/" + this.model.contactId;
          this.gobacklink = "https://www.vcad.ca/";
          break;
        case 500:
          share = "https://learn.tkc.edu/business-management-christian-college/";
          this.gobacklink = "https://www.tkc.edu/";
          break;
      }
      this.share = { date: null, link: share, copied: false, title: null, from: null, to: null, site: null, address: null };
      this.completed = true;
      console.log('this.model', this.model);
    }, error => {
      console.log(error);
      switch (this.brandId) {
        case 372:
          window.location.href = "https://www.career.college/thank-you/";
          break;
        case 373:
          window.location.href = this.french ? "https://www.collegecdi.ca/colombie-britannique/merci/" : "https://www.cdicollege.ca/study-on-campus/british-columbia/thank-you/"
          break;
        case 374:
          window.location.href = "https://www.reevescollege.ca/thank-you/";
          break;
        case 543:
          window.location.href = "https://www.vcad.ca/thank-you/";
          break;
        case 500:
          window.location.href = "https://www.tkc.edu/thank-you/";
          break;
        default:
          window.location.href = "https://www.cdicollege.ca/study-on-campus/british-columbia/thank-you/?done"
          break;
      }
    });

    window.onbeforeunload = function (e) {
      localStorage.removeItem("EmailsListInvitation");
    };
  }

  weekday(day: string) {
    switch (day) {
      case 'Mon':
        return 'Monday';
      case 'Tue':
        return 'Tuesday';
      case 'Wed':
        return 'Wednesday';
      case 'Thu':
        return 'Thursday';
      case 'Fri':
        return 'Friday';
      case 'Sat':
        return 'Saturday';
      case 'Sun':
        return 'Sunday';
    }
    return day;
  }

  thankYouImage() {
    switch (this.model.brandId) {
      case 372:
      case 373:
      case 374:
      case 543:
        return "thankyouimage.png";
      case 500:
        return "thankyouimage500.png";
    }
  }

  sendInvite() {
    let emails = localStorage.getItem("EmailsListInvitation");
    if (emails && emails.includes(this.model.email)) {
      this.model.email = "";
      return;
    }
    this.loadingService.show();
    this.http.post<CalendarResponse>(this.baseUrl + 'Appointment/InviteV2', this.model).subscribe(response => {
      if (!this.share.site) {
        this.share.site = response.link;
        var share = this.share;
        setTimeout(function () { share.site = null; }, 5000);
      }
      this.loadingService.hide();
      emails = emails && emails.length > 0 ? `${emails}, ${this.model.email}` : this.model.email;
      localStorage.setItem("EmailsListInvitation", emails);
      this.model.email = "";
    }, error => {
      console.log(error);
    });
  }

  GetIcsFileV2() {

    this.http.get(this.baseUrl + 'Appointment/GetIcsFileV2?time=' + this.model.dateAndTime + '&name=' + this.model.userName
      + '&email=' + this.model.email + '&title=' + this.model.title + '&usertimezone=' + this.model.userTimeZoneId + '&leadtimezone=' + this.model.leadTimeZoneId
      + '&address=' + this.model.address + '&meet=' + this.model.meet, { responseType: 'arraybuffer' }).subscribe(data => {
        var blob = new Blob([data], { type: 'text/calendar' });
        var url = window.URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.setAttribute("href", url);
        //link.setAttribute("download", fileName);
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }, error => {
        console.log(error);
      });
  }

  copyShare() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.share.link;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    if (!this.share.copied) {
      this.share.copied = true;
      var share = this.share;
      setTimeout(function () { share.copied = false; }, 3000);
    }
  }

  inviteInvalid() {
    return !this.model.email || !this.model.email.includes('@') || !this.model.email.includes('.');
  }

  copyLink() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.model.link;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    if (!this.model.copied) {
      this.model.copied = true;
      var model = this.model;
      setTimeout(function () { model.copied = false; }, 3000);
    }
  }

  isLC() {
    switch (this.model.brandId) {
      case 372:
      case 373:
      case 374:
      case 543:
        return true;
      case 500:
        return false;
    }
    return false;
  }

  isTKC() {
    switch (this.model.brandId) {
      case 372:
      case 373:
      case 374:
      case 543:
        return false;
      case 500:
        return true;
    }
    return false;
  }
}
